export enum SelectType {
  Filter = 'FILTER',
  Table = 'TABLE',
  Form = 'FORM',
  AutoAdjutForm = 'AUTO-ADJUST-FORM'
}
